import React, { Component } from "react";
import _, { map } from "lodash";
import Modal from "react-bootstrap/lib/Modal";
import Button from "react-bootstrap/lib/Button";
import NumberFormat from "react-number-format";
import EventEmitter from "../../services/event-emitter";
import { logError } from "../../services/utils";
import { postRequest, putRequest } from "../../api/ApiService";
import { incrementUnacceptedDecisions } from "../../api/SubmitDecisions";
import { changeLocation } from "../../api/Location";
import Fragment from "react-dot-fragment";

const PRICE_MIN = 0;
const PRICE_MAX = 99.99;
const FORECAST_MIN = 0;
const FORECAST_MAX = 99999999;
const DEFAULT_PRICE = 5;
const DEFAULT_FORECAST = 100000;

function initProducts(products) {
  let result = _.cloneDeep(products);

  Object.keys(result).forEach(product_id => {
    const product = result[product_id];

    if (product.forecast_id === 0 || product.player === null) {
      result[product_id].price = DEFAULT_PRICE;
      result[product_id].forecast = DEFAULT_FORECAST;
    } else if (product.price === 0) {
      result[product_id].price = DEFAULT_PRICE;
    }
  });

  return result;
}

export default class ModalPMDecisionsRevenueForecast extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: initProducts(props.products),
      original_products: props.products,
      isSaving: false,
      productValidations: {},
      currentRound: props.currentRound,
      roundInUrl: props.roundInUrl,
      rounds: props.rounds
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  goToCustomerAnalysis = e => {
    e.preventDefault();
    this.eventemitter.trigger("coaching-feedback-hide");
    changeLocation("/ceo/analysis/market");
  };

  showPopup = () => {
    this.eventemitter.trigger("coaching-feedback", [
      'Food for Thought',
      <Fragment>
        <b>Wow! You're looking to crush it this year!</b><br />
        But are you sure any mobile customer is willing to pay that high price for this product
      </Fragment>,
      'If so, how many units will the customer buy? I doubt any auto customers will buy',
      <Fragment>
        Before pricing your product, please double check <a href="/ceo/analysis/market" onClick={this.goToCustomerAnalysis}>customer analysis</a> to
        gain a better understanding of your customers needs/wants... you're welcome!
      </Fragment>
    ]);
  };

  showPopup2 = () => {
    this.eventemitter.trigger("coaching-feedback", [
      'Food for Thought',
      <Fragment>
        <b>Wow! You're looking to crush it this year!</b><br />
        But are you sure any customer is willing to pay that high price for this product
      </Fragment>,
      'If so, how many units will the customer buy?',
      <Fragment>
        Before pricing your product, please double check <a href="/ceo/analysis/market" onClick={this.goToCustomerAnalysis}>customer analysis</a> to
        gain a better understanding of your customers needs/wants... you're welcome!
      </Fragment>
    ]);
  };

  showPopup3 = () => {
    this.eventemitter.trigger("coaching-feedback", [
      'Food for Thought',
      'I see what you\'re doing! Low prices, higher demand for your product. Econ 101, I get it...but you should consider a few things.',
      <Fragment>
        <b>Is the price too low?</b><br />
        At a certain low price point, customers might think your product must not be good and won’t buy.
      </Fragment>,
      <Fragment>
        <b>How much of a Gross Margin (GM) will you make on each unit sold?</b><br />
        GM = (Selling Price - Unit Costs) / Selling Price. GM is also a key grading metric.
      </Fragment>
    ]);
  };

  showPopup4 = () => {
    this.eventemitter.trigger("coaching-feedback", [
      'Food for Thought',
      'I see what you\'re doing! Low prices, higher demand for your product. Econ 101, I get it...but you should consider a few things.',
      <Fragment>
        <b>Is the price too low?</b><br />
        At a certain low price point, customers might think your product must not be good and won’t buy.
      </Fragment>,
      <Fragment>
        <b>How much of a Gross Margin (GM) will you make on each unit sold?</b><br />
        GM = (Selling Price - Unit Costs) / Selling Price. GM is also a key grading metric.
      </Fragment>
    ]);
  };

  openModal = () => {
    if (this.props.tourMode === true) {
      this.showModalTour();
      return;
    }

    this.showModalDecisionsPricing();
  };

  componentDidMount() {
    this.eventemitter.on(
      "product-marketing-show-modal",
      this.showModalDecisionsPricing
    );
    this.eventemitter.on(
      "product-marketing-hide-modal",
      this.hideModalDecisionsPricing
    );
    this.eventemitter.on("product-marketing-force-update", this.rerender);
    this.eventemitter.on("pm-decisions-open-modal", this.openModal);
  }

  componentWillUnmount() {
    this.eventemitter.off(
      "product-marketing-show-modal",
      this.showModalDecisionsPricing
    );
    this.eventemitter.off(
      "product-marketing-hide-modal",
      this.hideModalDecisionsPricing
    );
    this.eventemitter.off("product-marketing-force-update", this.rerender);
    this.eventemitter.off("pm-decisions-open-modal", this.openModal);
  }

  rerender = () => {
    this.forceUpdate();
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state.currentRound !== nextProps.currentRound ||
      this.state.roundInUrl !== nextProps.roundInUrl ||
      (this.state.rounds.length === 0 && nextProps.rounds.length !== 0) ||
      this.state.original_products !== nextProps.products
    ) {
      this.setState({
        products: initProducts(nextProps.products),
        original_products: nextProps.products,
        currentRound: nextProps.currentRound,
        roundInUrl: nextProps.roundInUrl,
        rounds: nextProps.rounds
      });
    }
  }

  showModalTour = () => {
    // do nothing
  };

  showModalDecisionsPricing = () => {
    if (this.props.tourMode === true) {
      window.$("#modalDecisionsPricing").data("bs.modal", null);
      window.$("#modalDecisionsPricing").modal({
        keyboard: false,
        backdrop: "static",
        show: true
      });
      return;
    }

    if (this.props.hasAccess === true) {
      window.$("#modalDecisionsPricing").data("bs.modal", null);
      window.$("#modalDecisionsPricing").modal("show");
    } else {
      this.props.showRoleAlert();
    }
  };

  hideModalDecisionsPricing = () => {
    window.$("#modalDecisionsPricing").modal("hide");
  };

  createForecast(data) {
    return postRequest(
      `${process.env.REACT_APP_API_URL}team/price_forecasts/`
    ).send(data);
  }

  updateForecast(data, forecast_id) {
    return putRequest(
      `${process.env.REACT_APP_API_URL}team/price_forecasts/${forecast_id}/`
    ).send(data);
  }

  validatePriceAndForecast(product_id, product) {
    const { price, forecast } = product;

    const isPriceValid = price >= PRICE_MIN && price <= PRICE_MAX;
    const isForecastValid =
      forecast >= FORECAST_MIN && forecast <= FORECAST_MAX;

    return { [product_id]: { isPriceValid, isForecastValid } };
  }

  isEveryProductValid(productValidations) {
    return _.every(productValidations, productValidation =>
      _.every(productValidation)
    );
  }

  updateForecastRevenue = e => {
    if (this.props.tourMode === true) {
      // do nothing
      return;
    }

    this.setState({
      isSaving: true
    });

    let requests = [];

    const productValidations = {};
    let isEveryProductValid = true;

    Object.keys(this.state.products).forEach(product_id => {
      const product = this.state.products[product_id];

      const productValidation = this.validatePriceAndForecast(
        product_id,
        product
      );
      Object.assign(productValidations, productValidation);
      isEveryProductValid = isEveryProductValid && productValidation;
      if (!isEveryProductValid) {
        // don't send requests if any product is invalid
        return;
      }

      let data = {
        product: product_id,
        price: product.price,
        forecast: product.forecast
      };

      if (product.forecast_id > 0) {
        requests.push(this.updateForecast(data, product.forecast_id));
      } else {
        requests.push(this.createForecast(data));
      }
    });

    this.setState({ productValidations });
    if (!this.isEveryProductValid(productValidations)) {
      this.setState({ isSaving: false });
      // return early rather than wait on requests if any product is invalid
      return;
    }

    const joinRequest = Promise.all(requests);

    joinRequest
      .then(res => {
        const high_price_mobile_feedback =
          map(res, "body.high_price_mobile_feedback").filter(i => i === 1)
            .length > 0;
        const high_price_auto_feedback =
          map(res, "body.high_price_auto_feedback").filter(i => i === 1)
            .length > 0;
        const price = map(res, "body.price").filter(i => i <= 5).length > 0;
        const low_price_auto_feedback =
          map(res, "body.low_price_auto_feedback").filter(i => i === 1).length >
          0;

        if (high_price_mobile_feedback === true) {
          this.showPopup();
        } else if (high_price_auto_feedback === true) {
          this.showPopup2();
        } else if (price === true) {
          this.showPopup3();
        } else if (low_price_auto_feedback === true) {
          this.showPopup4();
        }

        this.setState(
          {
            isSaving: false,
            showModalDecisionsPricing: false
          },
          () => {
            this.props.showSuccessMessage('New price forecast was successfully set for your product(s)');
            incrementUnacceptedDecisions("marketing");
            this.hideModalDecisionsPricing();
            this.props.reloadData();
            this.props.getSubmissionData();
          }
        );
      })
      .catch(err => {
        logError(
          err,
          "ModalPMDecisionsRevenueForecast",
          "updateForecastRevenue"
        );
      });
  };

  updateState = (e, nonFormattedValue) => {
    const input = e.target;
    // use floatValue if nonFormattedValue is an object, otherwise parseFloat
    const value =
      (nonFormattedValue instanceof Object && nonFormattedValue.floatValue) ||
      parseFloat(nonFormattedValue);
    const key = input.dataset.name;
    const productId = parseInt(input.dataset.productId, 10);
    const products = this.state.products;

    if (productId in products) {
      if (key in products[productId]) {
        products[productId][key] = value;

        this.setState({ products });
      }
    }
  };

  get isSaveDisabled() {
    if (this.props.tourMode === false) {
      return this.state.isSaving;
    }

    return true;
  }

  render() {
    const isSaving = this.state.isSaving;
    let modalClassName = "modal fade";
    if (this.props.tourMode === true) {
      modalClassName = "modal";
    }

    return (
      <div
        className={modalClassName}
        id="modalDecisionsPricing"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-bigger">
          <div className="modal-content">
            <Modal.Header id="product-marketing-revenue-forecast-header">
              <div className="row">
                <div className="col-xs-7">
                  <h4
                    className="modal-title title-light-blue"
                    id="myModalLabel"
                  >
                    Products
                  </h4>
                </div>
                <div className="col-xs-5">
                  <p className="modal-p">Revenue Forecast</p>
                </div>
              </div>
            </Modal.Header>

            <Modal.Body>
              <div className="table-responsive mt-20">
                <table className="table">
                  <thead>
                    <tr className="border-none">
                      <th className="text-center">
                        <span></span>
                      </th>
                      <th className="text-center">
                        <span>Price</span>
                      </th>
                      <th className="text-center">
                        <span>Units Forecast</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(this.state.products).map(product_id => {
                      const product = this.state.products[product_id];
                      const validations = this.state.productValidations[
                        product_id
                      ];
                      const defaultValidations = {
                        isPriceValid: true,
                        isForecastValid: true
                      };
                      const { isPriceValid, isForecastValid } = validations
                        ? validations
                        : defaultValidations;

                      return (
                        <tr
                          className="text-center border-none"
                          key={product_id}
                        >
                          <th className="middle">Product {product.name}</th>
                          <td>
                            <NumberFormat
                              data-product-id={product_id}
                              data-name="price"
                              prefix="$"
                              thousandSeparator=","
                              decimalSeparator="."
                              decimalPrecision={2}
                              value={product.price}
                              onChange={this.updateState}
                              className={isPriceValid ? "" : "invalid"}
                            />
                          </td>
                          <td>
                            <NumberFormat
                              data-product-id={product_id}
                              data-name="forecast"
                              thousandSeparator=","
                              value={product.forecast}
                              onChange={this.updateState}
                              className={isForecastValid ? "" : "invalid"}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {!this.isEveryProductValid(this.state.productValidations) ? (
                  <span style={{ color: "#a94442" }}>
                    Price must be between {PRICE_MIN} and {PRICE_MAX}, and
                    forecast must be between {FORECAST_MIN} and {FORECAST_MAX}
                  </span>
                ) : null}
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                className="btn btn-cancel"
                onClick={this.hideModalDecisionsPricing}
                disabled={this.props.tourMode}
              >
                Cancel
              </Button>
              <Button
                id="product-marketing-revenue-forecast-save"
                className="btn btn-save"
                disabled={this.isSaveDisabled}
                onClick={!isSaving ? this.updateForecastRevenue : null}
              >
                {isSaving ? "Saving..." : "Save"}
              </Button>
            </Modal.Footer>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modal/ModalPMDecisionsRevenueForecast.js